import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableGroup/CheckableGroup.Fields.tsx
import React, { forwardRef, useContext, useMemo, Children, useEffect } from "react";
import clsx from "clsx";
var CheckableGroupFields = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className,
      children: childrenProp
    } = _b,
    rest = __objRest(_b, ["className", "children"]);
  const {
    maxItems,
    moreButton,
    setTotalItems,
    isExpanded
  } = useContext(CheckableGroupContext);
  const children = useMemo(() => {
    const childrenArray = Children.toArray(childrenProp);
    return {
      always: childrenArray.slice(0, maxItems),
      expanded: childrenArray.slice(maxItems)
    };
  }, [childrenProp, maxItems]);
  useEffect(() => {
    setTotalItems(Children.count(childrenProp));
  }, [childrenProp, setTotalItems]);
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    ref,
    className: clsx("pd-checkable-group__fields", className)
  }, rest), children.always, children.expanded.length !== 0 && !isExpanded ? moreButton : children.expanded);
});
var CheckableGroup_Fields_default = CheckableGroupFields;
export { CheckableGroup_Fields_default };